// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 13004-新增空间 新增空间信息 POST /web/v1/space/add */
export async function addSpace(
  body: API.SwimSpaceAddVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOLong>('/web/v1/space/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 13006-删除空间 逻辑删除空间 POST /web/v1/space/delete/${param0} */
export async function deleteSpace(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSpaceParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/space/delete/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 13003-空间详情 根据ID查询空间详情 GET /web/v1/space/detail/${param0} */
export async function getSpaceDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSpaceDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimSpaceDetailVo>(
    `/web/v1/space/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 13002-查询所有空间列表 查询所有启用的空间列表 GET /web/v1/space/list */
export async function getAllSpaceList(options?: { [key: string]: any }) {
  return request<API.YmResultVOListSwimSpaceListVo>('/web/v1/space/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 13001-空间列表查询（分页） 分页查询空间列表 POST /web/v1/space/page */
export async function getSpacePageList(
  body: API.SwimSpacePageQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimSpaceListVo>(
    '/web/v1/space/page',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 13007-更新空间状态 启用或禁用空间 POST /web/v1/space/status/${param0} */
export async function updateSpaceStatus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateSpaceStatusParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/space/status/${param0}`, {
    method: 'POST',
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 13005-修改空间 修改空间信息 POST /web/v1/space/update */
export async function updateSpace(
  body: API.SwimSpaceUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/space/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
